// @ts-nocheck
import {
    DispatchResetSelections,
    chain,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ResetSelections";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, DispatchResetSelections, props => {
    props.dispatch({
        type: "Greif/Pages/ProductDetails/ResetSelections",
    });
});
